import type { Style } from '@react-pdf/types'

type PdfContentItem = {
  text: string
  style?: Style
}

type PdfContent = Record<string, PdfContentItem>

export const PDF_CONTENT: PdfContent = {
  headerTitle: {
    text: 'RAPORT',
    style: { fontSize: 18, fontWeight: 'bold' }
  },
  title: {
    text: 'STYLU ŻYCIA MŁODYCH SPORTOWCÓW',
    style: {
      fontSize: 26,
      fontFamily: 'OpenSans',
      fontWeight: 'bold',
      // letterSpacing: 1.5,
      paddingHorizontal: 20,
      textAlign: 'center'
    }
  },
  paragraf_1_1: {
    text: 'Każda grupa sportowa trenuje według określonego planu treningowego.',
    style: {
      marginTop: 60
    }
  },
  paragraf_1_2: {
    text: 'Jednak na wyniki sportowe wpływa nie tylko trening, ale również styl życia zawodników jak sposób odżywiania, nawodnienie, sen oraz regeneracja.'
  },
  paragraf_1_3: {
    text: 'Niniejszy raport przedstawia zbiorczy obraz nawyków zawodników na podstawie anonimowej ankiety dotyczącej stylu życia młodych sportowców.'
  },
  paragraf_1_4: {
    text: 'Celem raportu jest pokazanie, które elementy stylu życia wspierają rozwój sportowy zawodników, a które mogą ograniczać energię, regenerację i efekty treningowe.'
  },
  paragraf_1_5: {
    text: 'Ten Raport nie ocenia, tylko pokazuje. Nie narzuca, tylko wskazuje możliwości.',
    style: {
      fontWeight: 'bold'
    }
  },
  wynik_subtitle_1: {
    text: 'AKTUALNY WYNIK RAPORTU'
  },
  p_wynik_2_1: {
    text: 'OBRAZ OGÓLNY'
  },
  p_wynik_2_2_1a: {
    text: 'W badaniu wzięło udział:',
    style: {
      fontSize: 15,
      paddingVertical: 0
    }
  },
  p_wynik_2_2_1: {
    text: 'Średni wynik grupy wyniósł:',
    style: {
      fontSize: 15
    }
  },
  p_wynik_2_2_2: {
    text: 'Oznacza to, że część zawodników posiada dobre nawyki wspierające trening, jednak w grupie występują również obszary wymagające poprawy w zakresie odżywiania, regeneracji i snu.'
  },
  p_wynik_2_3: {
    text: 'Aktualnie:',
    style: {
      marginTop: 10
    }
  },
  li_wynik_2_3_1: {
    text: 'w strefie „SŁABO”',
    style: {
      padding: 6
    }
  },
  li_wynik_2_3_2: {
    text: 'w strefie „ŚREDNIO”',
    style: {
      padding: 6
    }
  },
  li_wynik_2_3_3: {
    text: 'młodych sportowców znajduje się w strefie „SUPER”',
    style: {
      padding: 6
    }
  },
  strefa_1: {
    text: 'Strefa „SŁABO” ',
    style: {
      fontWeight: 'bold',
      paddingVertical: 0
    }
  },
  strefa_1a: {
    text: ' – ryzyko spadku formy',
    style: {
      fontWeight: 'bold',
      paddingVertical: 0
    }
  },
  p_strefa_1_1: {
    text: 'Zawodnicy w tej strefie posiadają styl życia, który może utrudniać rozwój sportowy. Najczęściej występują tu nieregularne posiłki, brak jedzenia przed lub po treningu, mała ilość snu, niskie nawodnienie oraz częste spożywanie słodyczy lub fast-foodów.',
    style: {
      fontSize: 12
    }
  },
  p_strefa_1_2: {
    text: 'W praktyce oznacza to, że organizm może nie mieć wystarczającej energii do treningu i regeneracji, co może prowadzić do szybszego zmęczenia, gorszej koncentracji na treningu oraz wolniejszego rozwoju sportowego.',
    style: {
      fontSize: 12
    }
  },
  p_strefa_1_3: {
    text: 'Nie oznacza to braku talentu czy zaangażowania, ale pokazuje, że styl życia może w tej chwili ograniczać możliwości sportowe zawodnika.',
    style: {
      fontSize: 12
    }
  },
  p_strefa_1_4: {
    text: 'Dobra wiadomość jest taka, że poprawa kilku podstawowych nawyków może stosunkowo szybko poprawić energię, regenerację i samopoczucie na treningach.',
    style: {
      fontSize: 12
    }
  },
  strefa_2: {
    text: 'Strefa „ŚREDNIO” ',
    style: {
      fontWeight: 'bold',
      paddingVertical: 0
    }
  },
  strefa_2a: {
    text: ' – obszary do poprawy',
    style: {
      fontWeight: 'bold',
      paddingVertical: 0
    }
  },
  p_strefa_2_1: {
    text: 'Zawodnicy w tej strefie trenują i mają potencjał sportowy, jednak w ich stylu życia pojawiają się błędy, które mogą ograniczać energię, regenerację i efekty treningowe. Najczęściej dotyczą one nieregularnych posiłków, zbyt małej ilości snu, zbyt małego nawodnienia lub zbyt częstego sięgania po słodycze i fast-food.',
    style: {
      fontSize: 12
    }
  },
  p_strefa_2_2: {
    text: 'W praktyce oznacza to, że zawodnik może trenować dobrze, ale nie wykorzystuje w pełni swojego potencjału, ponieważ organizm nie jest odpowiednio przygotowany do wysiłku i regeneracji. Często objawia się to zmęczeniem na treningu, spadkiem energii w ciągu dnia lub wolniejszą regeneracją po treningach.',
    style: {
      fontSize: 12
    }
  },
  p_strefa_2_3: {
    text: 'Jest to grupa, w której niewielkie zmiany w nawykach mogą bardzo szybko poprawić energię, regenerację i efekty treningowe.',
    style: {
      fontSize: 12
    }
  },
  strefa_3: {
    text: 'Strefa „SUPER” ',
    style: {
      fontWeight: 'bold',
      paddingVertical: 0
    }
  },
  strefa_3a: {
    text: ' – dobre nawyki sportowe',
    style: {
      fontWeight: 'bold',
      paddingVertical: 0
    }
  },
  p_strefa_3_1: {
    text: 'Zawodnicy w tej strefie posiadają nawyki, które sprzyjają energii, regeneracji i rozwojowi sportowemu. Najczęściej jedzą regularne posiłki, pamiętają o jedzeniu przed i po treningu, piją odpowiednią ilość wody oraz śpią wystarczająco długo.',
    style: {
      fontSize: 12
    }
  },
  p_strefa_3_2: {
    text: 'W praktyce oznacza to, że organizm ma energię do treningu, szybciej się regeneruje i lepiej reaguje na obciążenia treningowe. Tacy zawodnicy zazwyczaj rzadziej odczuwają brak energii na treningu i mają większe możliwości rozwoju sportowego.',
    style: {
      fontSize: 12
    }
  },
  p_strefa_3_3: {
    text: 'Można powiedzieć, że ta grupa ma bardzo dobre warunki do rozwoju sportowego, a ich styl życia wspiera efekty treningów.',
    style: {
      fontSize: 12
    }
  },
  signals: {
    text: 'Wskaźniki Znaczących Sygnałów',
    style: {
      margin: 0,
      paddingVertical: 0
    }
  },
  signals_1: {
    text: 'Wskaźniki opisujące główne czynniki ryzyka energetycznego zespołu',
    style: {
      fontSize: 11,
      margin: 0,
      paddingVertical: 0,
      paddingBottom: 30,
      lineHeight: 1
    }
  },
  summary: {
    text: 'INFORMACJA DLA TRENERA',
    style: {
      fontWeight: 'bold',
      textAlign: 'center'
    }
  },

  p_summary_1_1: {
    text: 'Wyniki ankiety pokazują, że poziom treningu to tylko jeden z elementów wpływających na rozwój sportowy zawodników. Drugim, bardzo ważnym elementem jest styl życia zawodników – czyli to, co robią pomiędzy treningami: jak jedzą, ile piją, ile śpią i jak się regenerują.',
    style: {
      marginTop: -20
    }
  },
  p_summary_1_1a: {
    text: 'W praktyce oznacza to, że część zawodników może trenować poniżej swoich możliwości nie dlatego, że trening jest zbyt lekki lub zbyt ciężki, ale dlatego, że organizm nie ma wystarczającej energii i regeneracji do pracy treningowej.'
  },
  p_summary_1_2: {
    text: 'Może to objawiać się:'
  },
  li_summary_1_2_1: {
    text: 'szybszym zmęczeniem podczas treningu,',
    style: {
      paddingVertical: 0
    }
  },
  li_summary_1_2_2: {
    text: 'spadkiem koncentracji,',
    style: {
      paddingVertical: 0
    }
  },
  li_summary_1_2_3: {
    text: 'wolniejszą regeneracją po treningach,',
    style: {
      paddingVertical: 0
    }
  },
  li_summary_1_2_4: {
    text: 'brakiem energii na kolejnych jednostkach treningowych,',
    style: {
      paddingVertical: 0
    }
  },
  li_summary_1_2_5: {
    text: 'mniejszą dynamiką i zaangażowaniem na treningu.',
    style: {
      paddingVertical: 0
    }
  },
  p_summary_1_3: {
    text: 'Oznacza to, że poprawa kilku podstawowych elementów stylu życia, takich jak regularne posiłki, jedzenie po treningu, odpowiednia ilość snu i nawodnienie, może wyraźnie poprawić energię zawodników na treningach oraz efektywność pracy treningowej.'
  },
  p_summary_1_4: {
    text: 'Można powiedzieć, że trening rozwija zawodnika, ale styl życia decyduje, ile z tego treningu organizm jest w stanie wykorzystać.'
  }
} satisfies Record<string, PdfContentItem>
